import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 75 — "Filipino virtual assistant — niche specialization & AI skills"
 * cluster service links (first 3 articles).
 *
 * Each Batch 75 article routes its primary commercial link to the automation
 * service page that matches its angle (Zapier/Make for niches, HubSpot for
 * executive, CRM for bookkeeping). The answer-first leads in
 * batch75Content.ts embed the link directly, but the lead-swap idempotency
 * guard can drop the lead when the Quick Answer duplicates the lead text.
 * This map is the RELIABLE fallback: `injectBatchServiceLink`
 * (batchContentOptimizer.ts) wraps the first in-body occurrence of each
 * anchor phrase in the service-page link, so the contextual service link
 * always renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH75_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "filipino-virtual-assistant-niches-2026": {
    url: "/zapier-make-automation-expert",
    anchor:
      /general VA who covers every niche is a hire the team underpays and overworks/i,
    label: "hire a Zapier and Make automation expert",
  },
  "filipino-executive-virtual-assistant": {
    url: "/hubspot-revops-architect",
    anchor:
      /admin who manages the inbox by hand is a hire the executive outgrows in a quarter/i,
    label: "hire a HubSpot RevOps architect",
  },
  "filipino-bookkeeping-virtual-assistant": {
    url: "/CRM-revops-architect",
    anchor:
      /bookkeeping VA who works by hand saves the rate but not the close/i,
    label: "hire a CRM RevOps architect",
  },
};
